import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllPaymentsBySubscriptionId = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/subscription/${id}/payments`);

export const savePaymentBySubscription = (id, payment) =>
  apiClient.post(`${REST_API_BASE_URL}/subscription/${id}/payment`, payment);

export const getPayment = (subid, paymentid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/subscription/${subid}/payment/${paymentid}`,
  );

export const updatePayment = (id, payment) =>
  apiClient.put(`${REST_API_BASE_URL}/payment/${id}`, payment);

export const deletePayment = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/payment/${id}`);

export default apiClient;
